const styles = () => ({
  root: {
    width: 540,
  },

  input: {
    padding: '10px 0',
  },

  actions: {
    margin: '20px 0',
    display: 'flex',
    justifyContent: 'flex-end',
  },

  footer: {
    bottom: '-40px',
    marginTop: 20,
    padding: '20px 0 20px 0',
  },

  p: {
    margin: '10px 0',
  },

  subtitle: {
    color: '#32383f',
    fontSize: 24,
    fontWeight: 400,
  },

  notificationBar: {
    marginTop: 20,
  },

  fieldMappingBox: {
    marginTop: 15,
  },

  warningIcon: {
    width: 16,
    marginRight: 16,
  },

  objectSwitch: {
    maxWidth: 140,
  },

  divider: {
    margin: '10px 0 5px',
  },

  loadingArea: {
    minHeight: 'unset',
  },

  error: {
    color: '#f44336',
  },

  success: {
    color: 'green',
    marginLeft: 16,
  },

  mappingInput: {
    width: '100%',
    display: 'flex',
  },

  popover: {
    minWidth: 280,
  },
});

export default styles;
